import cookie from "js-cookie";
import router from "@/router";
const { Message } = ELEMENT;

export const checkStatus = (code, msg) => {
  let errMessage = "";
  switch (code) {
    case 10000:
      errMessage = "参数校验异常";
      break;
    case 10001:
      errMessage = "系统用户已存在";
      break;
    case 10002:
      errMessage = "填写验证码有误";
      break;
    case 10003:
      errMessage = "用户名密码有误";
      break;
    case 10004:
      errMessage = "节点路由已存在";
      break;
    case 10005:
      errMessage = "权限必须包含父节点";
      break;
    case 10006:
      errMessage = "非法操作：该节点仅支持目录类型父节点";
      break;
    case 10007:
      errMessage = "非法操作：节点类型无法直接转换";
      break;
    case 10008:
      errMessage = "该角色存在关联用户，请先删除关联用户";
      break;
    case 10009:
      errMessage = "该部门存在关联用户，请先删除关联用户";
      break;
    case 10010:
      errMessage = "该部门存在关联角色，请先删除关联角色";
      break;
    case 10011:
      errMessage = "旧密码与原密码不一致";
      break;
    case 10012:
      errMessage = "如想下线自身可右上角退出";
      break;
    case 10013:
      errMessage = "不允许下线该用户";
      break;
    case 10014:
      errMessage = "父级菜单不存在";
      break;
    case 10015:
      errMessage = "该部门存在子部门，请先删除子部门";
      break;
    case 10016:
      errMessage = "系统内置功能不允许操作";
      break;
    case 10017:
      errMessage = "用户不存在";
      break;
    case 10018:
      errMessage = "无法查找当前用户所属部门";
      break;
    case 10019:
      errMessage = "部门不存在";
      break;
    case 10020:
      errMessage = "任务不存在";
      break;
    case 10021:
      errMessage = "参数配置键值对已存在";
      break;
    case 10101:
      errMessage = "不安全的任务，确保执行的加入@Mission注解";
      break;
    case 10102:
      errMessage = "所执行的任务不存在";
      break;
    case 11001:
      errMessage = "登录无效或无权限访问";
      localStorage.removeItem("afterSaleToken");
      localStorage.removeItem("oId");
      cookie.remove("afterSaleToken");
      router.push({ name: "RepairTrace" });
      break;
    case 11002:
      errMessage = "登录身份已过期";
      break;
    case 11003:
      errMessage = "无权限，请联系管理员申请权限";
      break;
    case 20001:
      errMessage = "当前创建的文件或目录已存在";
      break;
    case 20002:
      errMessage = "无需操作";
      break;
    case 20003:
      errMessage = "已超出支持的最大处理数量";
      break;
    case 30001:
      errMessage = "项目已存在";
      break;
    case 30003:
      errMessage = "未付款";
      break;
    case 30000:
      errMessage = "数据不存在";
      break;
    default:
      errMessage = msg ? msg : "操作失败";
  }

  Message({
    type: "error",
    message: errMessage,
  });
};
